module.exports = __webpack_public_path__ + "static/img/2020_welle1_01_gesundesklima_quadrat (1).e3859d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gruene/2020_welle1_01_gesundesklima_quadrat (1).png
// module id = 177
// module chunks = 1